import StockAdjustmentDetail from '@/models/StockAdjustment/StockAdjustmentDetail';

export default class StockAdjustmentDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.stockAdjustmentId  = '';
		this.stockAdjustmentStockAdjustmentNumber = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.qtySytem = '';
		this.qtyAdjustment = '';
		this.qtyAfter = '';
		this.reasonMultiple = '';
		this.controlCardStatusBeforeId  = '';
		this.controlCardStatusBeforeName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			stockAdjustmentId : '0',
			stockAdjustmentStockAdjustmentNumber : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			qtySytem : '0',
			qtyAdjustment : '0',
			qtyAfter : '0',
			reasonMultiple : '0',
			controlCardStatusBeforeId : '0',
			controlCardStatusBeforeName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}